import React from "react";
import {
    IconButton,
    Input,
    InputGroup,
    InputLeftElement, useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

export function SearchBar({
                              initialValue,
                              onChange,
                              debounce = 500,
                              ...props
                          }){
    const [value, setValue] = React.useState(initialValue)

    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, debounce)

        return () => clearTimeout(timeout)
    }, [value])

    const mainTeal = useColorModeValue("teal.300", "teal.300");
    const searchIconColor = useColorModeValue("gray.700", "gray.200");
    const inputBg = useColorModeValue("white", "gray.800");


    return (
        <InputGroup
            bg={inputBg}
            borderRadius="15px"
            w="200px"
            _focus={{
                borderColor: { mainTeal },
            }}
            _active={{
                borderColor: { mainTeal },
            }}
        >
            <InputLeftElement
                children={
                    <IconButton
                        bg="inherit"
                        borderRadius="inherit"
                        _hover={{}}
                        _active={{
                            bg: "inherit",
                            transform: "none",
                            borderColor: "transparent",
                        }}
                        _focus={{
                            boxShadow: "none",
                        }}
                        icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
                    ></IconButton>
                }
            />
            <Input
                {...props}
                value={value}
                onChange={e => setValue(e.target.value)}
                id="message"
                fontSize="xs"
                py="11px"
                borderRadius="inherit"
                placeholder="Type here..."
            />

        </InputGroup>

    );
}
